import { useSpecialsManagerAPIInterface } from "@dealer-center/ddc-pages-specials-manager-fetch";
import { Box, Button, TextInput } from "@dealer-center/core-components";
import { useMemo, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";

export const PagesSpecialsManagerUiInput = () => {
  const { searchValue: searchValueFromParams } = useParams();
  const [searchValue, setSearchValue] = useState(searchValueFromParams || "");
  const [submittedSearchValue, setSubmittedSearchValue] = useState(
    searchValueFromParams || ""
  );
  const memoizedSearchValue = useMemo(
    () => submittedSearchValue,
    [submittedSearchValue]
  );
  const { isLoading } = useSpecialsManagerAPIInterface({
    searchValue: memoizedSearchValue
  });
  const navigate = useNavigate();
  const submitSearch = () => {
    setSubmittedSearchValue(searchValue);
    navigate(searchValue);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          alignItems: "flex-end"
        }}
      >
        <TextInput
          id="PagesSpecialsManagerUiTextInput"
          label="Search"
          name="PagesSpecialsManagerUiTextInput"
          placeholder="Enter search value"
          value={searchValue}
          onChange={e => setSearchValue(e.target.value)}
          onKeyDown={e => {
            if (e.key === "Enter") {
              submitSearch();
            }
          }}
        />
        <Button
          analyticsConfiguration={{
            eventName: "PagesSpecialsManagerUi Search"
          }}
          buttonStyle="primary"
          disabled={!searchValue}
          isLoading={isLoading}
          onClick={() => submitSearch()}
        >
          Search
        </Button>
      </Box>
      <Outlet />
    </>
  );
};
